<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'barWidth', 'max', 'min'],
  watch: {

    max: {
      handler () {
        this.update()
      }
    },

    min: {
      handler() {
        this.update()
      }
    },

    values: {
      handler() {
        this.chartData.labels = this.values.labels,
        this.chartData.datasets = [
            {
              label: 'Balanço Energético',
              data: this.values.operation,
              barPercentage: 1,
              categoryPercentage: 0.5,
              backgroundColor: '#7367F0',
              borderWidth: 0
            },
            {
              label: 'Proposta',
              data: this.values.propose,
              barPercentage: 1,
              categoryPercentage: 0.5,
              backgroundColor: '#28C76F',
              borderWidth: 0
            },
            {
              type: 'line',
              label: 'Limite+',
              barPercentage: 1,
              categoryPercentage: 0.5,
              data: this.values.positive,
              yAxisID: "non-stacked",
              backgroundColor: 'rgba(134,135,191,0.48)',
              borderWidth: 0
            },
            {
              type: 'line',
              label: 'Limite-',
              yAxisID: "non-stacked",
              barPercentage: 1,
              categoryPercentage: 0.5,
              data: this.values.negative,
              backgroundColor: 'rgba(134,135,191,0.48)',
              borderWidth: 0
            },
            {
              type: 'line',
              label: 'Net',
              data: this.values.net,
              backgroundColor: 'rgb(210,67,67)',
              borderColor: 'rgb(210,67,67)',
              barPercentage: 1,
              categoryPercentage: 0.5,
              pointRadius: 4,
              borderWidth: 0,
              yAxisID: "non-stacked",
              fill: false,
              order: -1
            },
          ]
        this.$data._chart.update()
      },
      deep: true
    }
  },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            }
          ],
          yAxes: [{
            stacked: true,
            ticks: {
              suggestedMax: 10,
              suggestedMin: -10
            }
          }, {
            id: "non-stacked",
            stacked: false,
            display: false,
            ticks: {
              suggestedMax: 10,
              suggestedMin: -10
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    update () {
      this.options.scales.yAxes[0].ticks.suggestedMax = this.max
      this.options.scales.yAxes[0].ticks.suggestedMin = this.min

      this.options.scales.yAxes[1].ticks.suggestedMax = this.max
      this.options.scales.yAxes[1].ticks.suggestedMin = this.min

      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
